export default "<svg viewBox=\"0 0 19.95 12.09\"><path d=\"M1.06,1.06,10,10l8.92-8.91\"/></svg>";